import React, { useState } from "react";

import { Alert, notification } from "antd";
import { Helmet } from "react-helmet";

import { t } from 'i18next';
import { AlertContainer, Image, ImageContainer, StyledHome } from "./style";

import colors from "../../../theme/colors";
import { ChannelContext, IGroup, ISubgroup } from "../../../context/channel";
import { ITalksProps } from "../../../interfaces/university/talk";
import { API_URL, ENV } from "../../../settings";
import TopMenu from "../../../components/whitelabel/topMenu/TopMenu";
import SectionTalks from "../../../components/whitelabel/sectionTalks/SectionTalks";
import Description from "../../../components/whitelabel/description/Description";
import CarouselEventials from "../../../components/whitelabel/carousel/Carousel";
import Newsletter from "../../../components/whitelabel/newsletter/Newsletter";
import Footer from "../../../components/whitelabel/footer/Footer";


interface IAlert {
  message: string;
  type: "success" | "error";
}

const DEFAULT_PRIMARY_COLOR = colors.secondary;
const DEFAULT_SECONDARY_COLOR = colors.blue;
const DEFAULT_FOOTER_COLOR = colors.blue;
const DEFAULT_BG_COLOR = colors.background;
export const DEFAULT_LOGO_IMAGE =
  "https://s3.amazonaws.com/static.eventials.com/whitelabels/Logo-default.svg";
const DEFAULT_BANNER_IMAGE = [
  "https://s3.amazonaws.com/static.eventials.com/whitelabels/Banner-default.jpg",
];
const DEFAULT_DESCRIPTION_IMAGE =
  "https://s3.amazonaws.com/static.eventials.com/whitelabels/about_image_default.png";
const DEFAULT_DESCRIPTION_TITLE =
  "Este é o headline em que você pode ressaltar benefícios ou contar a história da sua marca";
const DEFAULT_DESCRIPTION_TEXT =
  "Aqui, você pode apresentar um breve resumo da organização da sua empresa ou negocio e o objetivo do seu canal";
const DEFAULT_DESCRIPTION_POSITION = "RIGHT";
const DEFAULT_NEWSLETTER_TITLE = "Convide sua audiência para se inscrever";
const DEFAULT_NEWSLETTER_TEXT =
  "Utilize esse recurso para capturar ainda mais leads";
const DEFAULT_WRAP = false;

const Home = () => {
  const { data, username, groups, channel, draftData, banners } =
    React.useContext(ChannelContext);

  const [searchString, setSearchString] = useState<string>("");
  const [emailNewsletter, setEmailNewsletter] = useState("");

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  let whiteLabelData = data;

  if (params?.preview === "true") {
    whiteLabelData = draftData;
  }

  const filterTalks = (groups: IGroup[], index: number, related: boolean) => {
    const group = groups[index];
    let talks = group.talks.filter(t => t.is_public);

    if (group.subgroups.length > 0) {
      group.subgroups.forEach((subgroup: ISubgroup) => {
        if (subgroup.talks.length > 0) {
          talks = talks.concat(subgroup.talks.filter((subgroupTalk: ITalksProps) =>
            !talks.some((t: ITalksProps) => t.id === subgroupTalk.id || !subgroupTalk.is_public)
          ));
        }
      });
    }

    const sectionTalksProps = {
      key: group.slug,
      color: whiteLabelData.config.colors?.colorPrimary || DEFAULT_PRIMARY_COLOR,
      title: group.name,
      colorBackground: whiteLabelData.config.colors?.colorSectionTalks || DEFAULT_BG_COLOR,
      talks: talks,
      slug: group.slug,
      description: group.description,
      owner: username,
      wrap: whiteLabelData.config.wrapTalks || DEFAULT_WRAP,
      apiUrl: API_URL,
      relationed: related,
      enableLink: true,
      url: group.url,
      channel: channel,
      group_is_public: groups[index].is_public
    };

    return sectionTalksProps;
  };

  const handleNewsletter = () => {
    let headers: any = {
      Accept: "application/json",
      "Content-Type": "application/json"
    };

    if (ENV === "staging") {
      headers["Authorization"] = "Basic ZXZlbnRpYWxzOnczYjFuNHIhQCM=";
    }

    fetch(`${API_URL}/api/whitelabel/${channel}/newsletter/`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        email: emailNewsletter,
      }),
    }).then(async (res) => {
      if (res.status === 200) {
        notification.success(
          { message: t('newsletter.success') }
        );
      } else {
        const body = await res.json();
        let message = t('newsletter.fail');

        if (body.message === "missing email") {
          message = t('newsletter.missingEmail');
        } else if (body.message === "invalid email") {
          message = t('newsletter.invalidEmail');
        }

        notification.error(
          { message: message }
        );
      }
    });
  };

  const isMobile = window.matchMedia(
    "only screen and (max-width: 760px)"
  ).matches;
  return (
    <StyledHome>
      <Helmet>
        <title>{`${data.name}`}</title>
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Eventials" />
        <meta property="og:title" content={`Webinars - ${data.name}`} />
        <meta property="og:description" content={`White Label ${channel}`} />
        <meta property="og:image" content={whiteLabelData.images.logo} />
        <meta property="og:image:alt" content={channel} />
      </Helmet>

      <TopMenu
        key="topMenu"
        trilhaConteudo
        transparent={
          whiteLabelData.header.transparent
            ? whiteLabelData.header.transparent
            : false
        }
        logoLightMode={
          whiteLabelData.images.logo
            ? whiteLabelData.images.logo
            : DEFAULT_LOGO_IMAGE
        }
        searchString={searchString}
        setSearchString={setSearchString}
        handleSearch={() => { }}
      />

      <CarouselEventials
        images={banners.length > 0 ? banners : DEFAULT_BANNER_IMAGE}
        imagesMobile={banners.length > 0 ? banners : DEFAULT_BANNER_IMAGE}
      />

      {groups.slice(0, 2).map((group: IGroup, index: number) => {
        const talksProps = filterTalks(groups, index, false);
        return groups[index].is_public ? (
          talksProps.talks.length > 0 && <SectionTalks {...talksProps} />
        ) : (
          <SectionTalks {...talksProps} />
        )
      })}

      <Description
        // idForAnchor='descriptionBlock'
        title={whiteLabelData.body.eventAbout?.title || DEFAULT_DESCRIPTION_TITLE}
        text={whiteLabelData.body.eventAbout?.description || DEFAULT_DESCRIPTION_TEXT}
        color={whiteLabelData.config.colors?.colorSecondary || DEFAULT_SECONDARY_COLOR}
        image={whiteLabelData.images?.about_image || DEFAULT_DESCRIPTION_IMAGE}
        position={whiteLabelData.body.eventAbout?.position || DEFAULT_DESCRIPTION_POSITION}
      />


      {groups.slice(2).map((group: IGroup, index: number) => {
        const talksProps = filterTalks(groups, index + 2, index === 0);
        return groups[index + 2].is_public ? (
          talksProps.talks.length > 0 && <SectionTalks {...talksProps} />
        ) : (
          <SectionTalks {...talksProps} />
        )
      })}

      {whiteLabelData.config.showAditionalBanner && (
        <ImageContainer>
          {isMobile ? (
            <Image src={whiteLabelData.config.aditionalBannerMobile} />
          ) : (
            <Image src={whiteLabelData.config.aditionalBanner} />
          )}
        </ImageContainer>
      )}

      {whiteLabelData?.config?.newsletter?.showNewsletter && (
        <Newsletter
          idForAnchor="newsletter"
          colorSecondary={
            whiteLabelData.config.newsletter?.colorSecondary
              ? whiteLabelData.config.newsletter.colorSecondary
              : DEFAULT_SECONDARY_COLOR
          }
          colorPrimary={
            whiteLabelData.config.newsletter?.colorPrimary
              ? whiteLabelData.config.newsletter.colorPrimary
              : DEFAULT_PRIMARY_COLOR
          }
          title={
            whiteLabelData.config.newsletter?.title
              ? whiteLabelData.config.newsletter.title
              : DEFAULT_NEWSLETTER_TITLE
          }
          description={
            whiteLabelData.config.newsletter?.description
              ? whiteLabelData.config.newsletter.description
              : DEFAULT_NEWSLETTER_TEXT
          }
          onClick={handleNewsletter}
          setEmailNewsletter={setEmailNewsletter}
        />
      )}

      <Footer
        idForAnchor="footer"
        companyName={whiteLabelData.name}
        image={
          whiteLabelData.footer.logo
            ? whiteLabelData.footer.logo
            : whiteLabelData.images.logo
              ? whiteLabelData.images.logo
              : DEFAULT_LOGO_IMAGE
        }
        color={
          whiteLabelData.footer.color
            ? whiteLabelData.footer.color
            : DEFAULT_FOOTER_COLOR
        }
        textColor={
          whiteLabelData.footer.footerTextColor
            ? whiteLabelData.footer.footerTextColor
            : DEFAULT_FOOTER_COLOR
        }
        hasMarginTop
        social={whiteLabelData.footer.social}
      />
    </StyledHome>
  );
};

export default Home;
export { DEFAULT_PRIMARY_COLOR };
